import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { VBaseSelect } from '../VBaseSelect';
import VInnerLanguageSwitch from './VInnerLanguageSwitch';
import type { VLanguageSwitchProps } from './type';

const VLanguageSwitch = (
  {
    languageList,
    selectedLanguage,
    onItemClick,
    placement = 'bottom',
  }: VLanguageSwitchProps,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  const onChange = (e: any) => {
    const selectedValue = e?.target.value;
    const selectedItem = languageList.find(
      item => item.value === selectedValue,
    );
    if (selectedItem) {
      onItemClick?.(selectedItem);
    }
  };

  return (
    <VBaseSelect
      itemList={languageList}
      value={selectedLanguage}
      onChange={onChange}
      placement={placement}
    >
      <VInnerLanguageSwitch
        ref={ref}
        selectedLanguage={selectedLanguage}
        languageList={languageList}
      />
    </VBaseSelect>
  );
};

export default forwardRef(VLanguageSwitch) as (
  props: VLanguageSwitchProps & {
    ref?: React.ForwardedRef<HTMLDivElement>;
  },
) => ReturnType<typeof VLanguageSwitch>;
